/**
 * 国家/地区
 */

import Base from './Base';


export default class Region extends Base {
  // 主要以Trip的region_info_maps的region结构为准
  schema = {
    region_id: Number,
    region_cn: String,
    region_en: String,

    pic_url: String,
    ascription_cn: String,
    ascription_en: String,
    type: String
  };

  // region.getAllAndClassify
  static parseInput(obj) {
    return {
      region_id: obj.region_id,
      region_cn: obj.cn_name,
      region_en: obj.en_name
    };
  }

  // city.search()
  static parseInput2(obj) {
    return {
      region_id: obj.id,
      region_cn: obj.cn_name,
      region_en: obj.en_name,
      pic_url: obj.pic_url,
      ascription_cn: obj.ascription_cn,
      ascription_en: obj.ascription_en,
      type: obj.type
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/Region.js